var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'WeRUNの歩数はiPhoneのヘルスケアと異なる原因'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("アカウントの切り替えや、複数スマホでのログイン、スマホのタイムゾーンを東京以外に設定した場合、WeRUNアプリの歩数はヘルスケアと異なることがあります。"),_c('br'),_vm._v("また、ヘルスケアの歩数データは他のアプリに更新されることがあります。")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccc5e972","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help10.vue
// module id = iCjT
// module chunks = 0